/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable no-return-assign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CommonStudySelector from '../common/CommonStudySelector';
import SmartSearch from '../common/SmartSearch/SmartSearch';
import basesIcon from '../../images/bases-small-icon_blue.png';
import basesHoverIcon from '../../images/bases-small-icon.png';
import basesDisabledIcon from '../../images/bases_icon_disabled.png';
import enlargeIcon from '../../images/enlarge-icon_48-67-93.png';
import enlargeHoverIcon from '../../images/enlarge-icon_brown.png';
import runIcon from '../../images/run_report_icon_normal.png';
import runHoverIcon from '../../images/run_report_icon_hover.png';
import targetDisabledIcon from '../../images/target-icon_grey.png';
import targetIcon from '../../images/target-icon_blue.png';
import targetHoverIcon from '../../images/target-hover_icon.png';
import runDisabledIcon from '../../images/run_report_icon_disabled.png';
import {
  MME_FEATUREID, ADD_MME_GRID_BASE, FLEX_STUDY_TAG,
  ADD_MME_GRID_TARGET,
} from '../../constants';
import * as mmeActions from '../../actions/mmeActions';
import { GEOGRAPHY_BASES } from '../../actions/actionTypes';
import { saveTrackingData } from '../../util/trackerUtils';
import GenericButton from '../common/GenericButton';
import Modal from '../common/Modal/Modal';
import * as urls from '../../actions/urlTypes';
import { RUN_CLICKED } from './MMEConstants';

const targetMaxLimitModalStyle = {
  width: '30%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

const runReportModalStyle = {
  width: '30%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

class MMESmartSearchEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enlargeIcon: true,
      baseBtnDisabled: true,
      targetBtnDisabled: true,
      runBtnDisabled: false,
      isTagInputExpanded: true,
      weightTypeChanged: false,
    };
    this.smartSearchBox = React.createRef();
  }

  componentDidMount() {
    if (!this.props.mediaList && this.props.mmeStudy) {
      const mediaListParams = {
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: this.props.mmeStudy.pn,
      };
      this.props.mmeActions.fetchMediaList(mediaListParams);
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.kpiInfo !== this.props.kpiInfo) {
      if (nextProps.kpiInfo !== undefined) {
        this.setState({
          baseBtnDisabled: false,
          targetBtnDisabled: false,
        });
      } else {
        this.setState({
          baseBtnDisabled: true,
          targetBtnDisabled: true,
        });
      }
    }
    if (nextProps.mmeStudy !== this.props.mmeStudy) {
      if (!this.state.weightTypeChanged) {
        const mediaListParams = {
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: nextProps.mmeStudy.pn,
        };
        this.props.mmeActions.fetchMediaList(mediaListParams);
        const fetchStandardBasetParams = {
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: nextProps.mmeStudy.pn,
        };
        if (!this.props.loginResponse.data.universityUser) {
          this.props.mmeActions.fetchStandardBaseList(fetchStandardBasetParams);
        }
      } else {
        this.setState({ weightTypeChanged: false });
      }
    }
  }

  setSelectedStudy = (selectedStudy, updatedWeightType) => {
    this.props.handleStudyChange(selectedStudy, updatedWeightType);
  }

  setTagInputData = () => {
    this.setState((prevState) => ({
      enlargeIcon: !prevState.enlargeIcon,
      isTagInputExpanded: !prevState.isTagInputExpanded,
    }));
  }

  handleMMEEdit = (idKey, dataSmartSearch) => {
    this.smartSearchBox
      .current
      .editCrosstabGrid(idKey, dataSmartSearch);
  };

  /* Method to handle mouse over
    */
  mouseOver = e => {
    const event = e;
    event.currentTarget.childNodes[0].src =
      event.currentTarget.childNodes[0].dataset.hoversrc;
  };

  /**
   * Method to handle mouse out
   */
  mouseOut = e => {
    const event = e;
    event.currentTarget.childNodes[0].src =
      event.currentTarget.childNodes[0].dataset.src;
  };

  /**
   * Move Rows & columns to Cross tab ToolPallate
   */
  handleMove = targetGrid => {
    const {
      expressionFormed,
      objectsAdded,
      selectedCategoryID,
      tags,
    } = this.smartSearchBox.current.state;
    this.smartSearchBox.current.handleSelectedIndexState();
    const { mmeStudy, loginResponse, activeAccountId, gridData,
      sampleWeightedKPIs } = this.props;
    const objSmartSearchArray = [
      { expressionFormed, objectsAdded, selectedCategoryID, tags },
    ];
    const expression = expressionFormed.join(' ');
    if ((gridData.TargetsDataGrid.length > urls.MME_TARGET_COUNT - 1) && targetGrid === 'TargetsDataGrid') {
      this.targetMaxLimitModal.show();
    } else {
      if (mmeStudy && expressionFormed.length > 0) {
        const selectedNames = [
          objectsAdded.reduce(
            (acc, { shortText }) => `${acc} ${shortText}`,
            '',
          ),
        ];
        const geographyBase = GEOGRAPHY_BASES.some(base =>
          expression.includes(base),
        );
        let recTypes = [];
        if (geographyBase) {
          recTypes.push('G');
        } else {
          recTypes = [
            objectsAdded.reduce(
              (acc, { recType }) => `${recType}`,
              '',
            ),
          ];
        }
        const sampleWeightedParams = {
          token: loginResponse.data.token,
          uid: loginResponse.data.uid,
          accountId: activeAccountId,
          productNo: mmeStudy.pn,
          weightType: this.props.mmeWeightTypes.wt,
          divisor: this.props.mmeWeightTypes.dv,
          gridData:
            gridData[targetGrid] &&
              (targetGrid !== 'TargetDataGrid' && targetGrid !== 'BaseDataGrid')
              ? gridData[targetGrid]
              : [],
          expressionList: [expressionFormed.join(' ')],
          originalNames: selectedNames,
          selectedNames,
          targetGrid,
          recTypes,
          objSmartSearchArray,
        };
        let action = '';
        const responseData = [];
        switch (targetGrid) {
          case 'TargetsDataGrid': action = ADD_MME_GRID_TARGET; break;
          case 'BasesDataGrid': action = ADD_MME_GRID_BASE; break;
          default: action = ''; break;
        }
        if (action !== '') {
          this.callSaveTrackerFn({ action, attributes: { expression: selectedNames } });
        }
        if (this.props.mmeStudy &&
          this.props.mmeStudy.st
            .toLowerCase().includes(FLEX_STUDY_TAG)) {
          responseData.push(sampleWeightedKPIs[expression].data[0]);
          sampleWeightedParams.response = responseData;
        } else {
          sampleWeightedParams.response = sampleWeightedKPIs[expression].data;
        }
        this.props.mmeActions.getSampleWeightedData(sampleWeightedParams);
        this.smartSearchBox.current.resetAll();
        this.setState({
          baseBtnDisabled: true,
          targetBtnDisabled: true,
        });
      }
      if(this.props.isEnableMMEViewer && targetGrid === 'TargetsDataGrid')
        this.runReportModal.show();
    }
  };

  resetAll = () => {
    this.setState({
      baseBtnDisabled: true,
      targetBtnDisabled: true,
    });
  }

  updateReportTypeAction = type => {
    this.props.mmeActions.updateReportType(type);
  }

  updateDimensionType = type => {
    this.props.mmeActions.updateDimensionType(type);
  }

  callSaveTrackerFn = ({ action, attributes = undefined }) => {
    const productNo = this.props.mmeStudy !== undefined ?
      this.props.mmeStudy.pn : undefined;
    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      productNo,
      moduleName: 'MME',
      attributes,
      action,
    });
  }

  handleChangeWeightType = weightType => {
    const { mmeStudy } = this.props;
    const updatedStudyItem = {
      ...mmeStudy,
      wt: weightType.wt,
    };
    this.props.updateModuleStudy('mme', updatedStudyItem, weightType);
    this.setState({ weightTypeChanged: true });
    if (this.props.isEnableMMEViewer) {
      this.props.runReportAfterWeightChange(weightType.wt);
    } else if (this.props.mmeAllTargets && this.props.mmeAllTargets.length > 1) {
      this.props.mmeActions.clearTargets(this.props.landingTarget);
    }
  }

  handleSelect = e => {
    this.props.mmeActions.updateSelectedMediaVehicle(e);
  };

  updateSelectedAction = selectedItems => {
    this.props.mmeActions.updateStatementVariables(selectedItems);
  };


  render() {
    const { studies, getSampleWeighted, fetchKPI, mmeStudy, gridData,
      runMMEReport, landingTarget } = this.props;
    return (<div className="smart-search-editor">
      <div className="appBreadcrumb">
        <div className="crosstab-study-selector mme-header-margin-left">
          <CommonStudySelector
            data-test="commonStudySelectComp"
            studies={studies}
            featureID={MME_FEATUREID}
            defaultStudy={mmeStudy}
            setMethod={this.setSelectedStudy}
            showWeightType
            handleChangeWeightType={this.handleChangeWeightType}
            menuName="MME"
            selectedWeightType={this.props.mmeWeightTypes}
          />
        </div>
        <div className="essential-breadcrumb">
          <span className="parent">Essentials / </span>MME
        </div>
      </div>
      <div className="mme-header-margin-left">
        <SmartSearch
          data-test="SmartSearchComp"
          toggleSearchEditor={this.props.toggleSearchEditor}
          selectedModule="MME"
          moduleStudy={mmeStudy}
          getSampleWeighted={getSampleWeighted}
          fetchKPI={fetchKPI}
          gridData={gridData}
          removeKPI={this.props.removeKPI}
          // runVisaHaul={this.props.runVisaHaul}
          // dataScreen={this.props.dataScreen}
          ref={this.smartSearchBox}
          // viewerGridType={
          //   this.props.crosstabTableList &&
          //   this.props.crosstabTableList.length > 0 &&
          //   this.props.crosstabTableList[0].viewerGridType
          // }
          trackerFn={this.props.trackerFn}
          isTagInputExpanded={this.state.isTagInputExpanded}
          resetAll={this.resetAll}
        />
        <div className="move-to-datahaul-wrapper">
          <div className="button-group">
            <button
              type="button"
              className="mri-mme-btn"
              onClick={() =>
                this.setState((prevState) => ({
                  isTagInputExpanded: !prevState.isTagInputExpanded,
                }))
              }
              title="Expand Smart Search"
              onMouseOver={this.mouseOver}
              onMouseOut={this.mouseOut}
            >
              <img
                className="mri-mme-btn-icon-expand"
                src={this.state.enlargeIcon ? enlargeIcon : enlargeHoverIcon}
                data-src={this.state.enlargeIcon ? enlargeIcon : enlargeHoverIcon}
                data-hoversrc={enlargeHoverIcon}
                alt="Enlarge icon"
              />
              <p className="mri-mme-btn-label">EXPAND</p>
            </button>
            <button
              type="button"
              className="mri-mme-btn"
              onClick={() => this.handleMove('BasesDataGrid')}
              title="Move to bases"
              onMouseOver={this.mouseOver}
              onMouseOut={this.mouseOut}
              disabled={this.state.baseBtnDisabled}
            >
              <img
                className="mri-mme-btn-icon-expand"
                src={this.state.baseBtnDisabled ? basesDisabledIcon : basesIcon}
                data-src={this.state.baseBtnDisabled ? basesDisabledIcon : basesIcon}
                data-hoversrc={this.state.baseBtnDisabled ? basesDisabledIcon : basesHoverIcon}
                alt="Move to bases"
              />
              <p className="mri-mme-btn-label">BASES</p>
            </button>
            <button
              type="button"
              className="mri-mme-btn"
              onClick={() => this.handleMove('TargetsDataGrid')}
              title="Move to targets"
              onMouseOver={this.mouseOver}
              onMouseOut={this.mouseOut}
              disabled={this.state.targetBtnDisabled}
            >
              <img
                className="mri-mme-btn-icon-expand"
                src={this.state.targetBtnDisabled ? targetDisabledIcon : targetIcon}
                data-src={this.state.targetBtnDisabled ? targetDisabledIcon : targetIcon}
                data-hoversrc={this.state.targetBtnDisabled ? targetDisabledIcon : targetHoverIcon}
                alt="Move to targets"
              />
              <p className="mri-mme-btn-label">TARGETS</p>
            </button>
            <button
              type="button"
              className="mri-mme-btn"
              onClick={() => runMMEReport(landingTarget, RUN_CLICKED)}
              title="Run MME"
              onMouseOver={this.mouseOver}
              onMouseOut={this.mouseOut}
            >
              <img
                className="mri-mme-btn-icon-run"
                src={this.state.runBtnDisabled ? runDisabledIcon : runIcon}
                data-src={this.state.runBtnDisabled ? runDisabledIcon : runIcon}
                data-hoversrc={this.state.runBtnDisabled ? runDisabledIcon : runHoverIcon}
                alt="Run MME"
              />
            </button>
            <Modal
              title="Max target limit reached"
              ref={node => (this.targetMaxLimitModal = node)}
              dialogStyles={targetMaxLimitModalStyle}
            >
              <h5>MME reports can include up to {urls.MME_TARGET_COUNT_IN_WORDS} targets.</h5>
              <h5>To add more targets please delete one or more of your previously selected targets.</h5>
              <div className="text-right">
                <GenericButton
                  name="Ok"
                  onBtnClick={() => this.targetMaxLimitModal.hide()}
                />
              </div>
            </Modal>
            <Modal
              title="Run Report"
              ref={node => (this.runReportModal = node)}
              dialogStyles={runReportModalStyle}
            >
              <h5>A data point was added, edited or deleted.</h5>
              <h5>Please run your report again to view updated selection(s).</h5>
              <div className="text-right">
                <GenericButton
                  name="Ok"
                  onBtnClick={() => this.runReportModal.hide()}
                />
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </div>);
  }
}

MMESmartSearchEditor.propTypes = {
  studies: PropTypes.arrayOf(PropTypes.shape({})),
  updateModuleStudy: PropTypes.func,
  handleStudyChange: PropTypes.func,
  getSampleWeighted: PropTypes.func,
  fetchKPI: PropTypes.func,
  removeKPI: PropTypes.func,
  mmeStudy: PropTypes.shape({
    st: PropTypes.string,
    pn: PropTypes.number,
  }),
  gridData: PropTypes.shape({
    TargetsDataGrid: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  kpiInfo: PropTypes.shape({}),
  mediaList: PropTypes.shape({}),
  toggleSearchEditor: PropTypes.func,
  mmeActions: PropTypes.shape({
    fetchMediaList: PropTypes.func,
    getSampleWeightedData: PropTypes.func,
    updateSelectedMediaVehicle: PropTypes.func,
    updateStatementVariables: PropTypes.func,
    updateReportType: PropTypes.func,
    updateDimensionType: PropTypes.func,
    fetchStandardBaseList: PropTypes.func,
    clearTargets: PropTypes.func,
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      universityUser: PropTypes.bool,
      token: PropTypes.string,
    }),
  }),
  updateSelectedMediaVehicle: PropTypes.func,
  activeAccountId: PropTypes.number,
  runMMEReport: PropTypes.func,
  sampleWeightedKPIs: PropTypes.shape({}),
  trackerFn: PropTypes.func,
  landingTarget: PropTypes.string,
  isEnableMMEViewer: PropTypes.bool,
  mmeWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
  runReportAfterWeightChange: PropTypes.func,
  mmeAllTargets: PropTypes.arrayOf(PropTypes.shape({})),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    studies: state.study.studies,
    selectedBase: state.mme.selectedBase.selectedBase,
    standardBaseLists: state.mme.standardBaseLists,
    sampleWeightedKPIs: state.crosstab.sampleWeightedKPIs,
    kpiInfo: state.crosstab.kpiInfo,
    mediaList: state.mme.mediaList,
    selectedMediaVehicleIndex: state.mme.selectedMediaVehicleIndex,
    mmeStudy: state.study.mmeStudy,
    isEnableMMEViewer: state.mme.isEnableMMEViewer,
    mmeWeightTypes: state.study.mmeWeightTypes,
    mmeAllTargets: state.mme.mmeAllTargets,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    mmeActions: bindActionCreators(mmeActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(MMESmartSearchEditor);
